import Link from "next/link";
import styled, { css } from "styled-components";
import { Flex } from "../../components/Grid";
import {
  Caption1,
  Footnote,
  Headline,
  Subhead,
} from "../../components/Typography";
import { VerifiedToken } from "../../components/VerifiedToken";
import { Creator } from "../../dropTypes";
import {
  hideAboveMobile,
  hideOnMobile,
  xSmallScreen,
} from "../../lib/mediaQuery";
import { CreatorContainer, CreatorImage } from "./creatorImage";

interface Props {
  creator: Creator;
  onClick?: () => void;
}

export const CreatorThumbnail = ({ creator, onClick }: Props) => {
  if (!creator?.image) {
    return <div />;
  }

  return (
    <Link
      href={`/${creator.slug}`}
      css={`
        color: inherit;
        :hover {
          text-decoration: none;
          color: inherit;
        }
      `}
    >
      <CreatorContainer direction={"column"} onClick={onClick}>
        <CreatorImage imageUrl={creator?.image} />
        <ThumbnailFooter direction={"column"}>
          <ArtistName align={"center"}>
            <Headline
              css={`
                ${hideOnMobile};
                max-width: 150px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              `}
            >
              {creator?.name}
            </Headline>
            <Subhead
              css={`
                ${hideAboveMobile};
                font-weight: 600;
                max-width: 95px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              `}
            >
              {creator?.name}
            </Subhead>
            {creator?.verified && (
              <Flex align={"center"}>
                <VerifiedToken />
              </Flex>
            )}
          </ArtistName>
          <SlugDesktop>@{creator?.slug}</SlugDesktop>
          <SlugMobile>@{creator?.slug}</SlugMobile>
        </ThumbnailFooter>
      </CreatorContainer>
    </Link>
  );
};

const borderRadius = css`
  border-radius: 2px;
`;

const ThumbnailFooter = styled(Flex)`
  justify-content: center;
  align-items: center;
  margin-top: var(--spacing-xxs);
  padding: var(--spacing-xs);
  flex-wrap: nowrap;
  ${borderRadius};
  ${xSmallScreen(
    css`
      padding: var(--spacing-xs) var(--spacing-xxs);
    `
  )};
`;

const ArtistName = styled(Flex)`
  flex-wrap: nowrap;
  align-items: center;
`;

const SlugDesktop = styled(Footnote)`
  color: var(--creator-slug-color);
  ${hideOnMobile};
`;

const SlugMobile = styled(Caption1)`
  color: var(--creator-slug-color);
  ${hideAboveMobile}
`;
